module.exports = __webpack_public_path__ + "static/media/mysql.c9ff5622.svg";